if (!customElements.get('xcf-pdp-v1')) {
  customElements.define(
    'xcf-pdp-v1',
    class extends HTMLElement {
      connectedCallback() {
        this.installMap = this.readInstallMap();
        this.productRoot = this.querySelector('.main-product');
        this.form = this.productRoot?.querySelector('.js-main-product-form');
        if (!this.installMap.length || !this.form) return;
        this.form.addEventListener('change', () => requestAnimationFrame(() => this.updateInstallation()));
        this.updateInstallation();
      }

      readInstallMap() {
        const source = this.querySelector('[data-xcf-variant-install-map]');
        if (!source) return [];
        try {
          return JSON.parse(source.textContent);
        } catch (error) {
          return [];
        }
      }

      updateInstallation() {
        const selectedId = Number(this.form.querySelector('input[name="id"]')?.value);
        const variant = this.installMap.find((item) => Number(item.id) === selectedId);
        if (!variant) return;
        const selected = variant.options.join(' ').toLowerCase();
        let label = this.dataset.installFallback;
        let answer = this.dataset.installOtherAnswer;
        if (selected.includes('replacement')) {
          label = this.dataset.installReplacement;
          answer = this.dataset.installReplacementAnswer;
        } else if (selected.includes('cover')) {
          label = this.dataset.installCover;
          answer = this.dataset.installCoverAnswer;
        }
        this.productRoot?.querySelectorAll('[data-xcf-install-value]').forEach((node) => {
          node.textContent = label;
        });
        this.productRoot?.querySelectorAll('[data-xcf-install-answer]').forEach((node) => {
          node.textContent = answer;
        });
      }
    },
  );
}
